<template>
  <div class="city-wrapper wp-city">
    <!--     <div class="vld-parent mycenter">
            <loading :active.sync="isLoading"
            :is-full-page="fullPage"></loading>
        </div>     -->
    <subpage-header>

      <div slot="bread">
        <ul itemscope itemtype="http://schema.org/BreadcrumbList">

          <li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
            <a href="https://holydwoodskyline.com/" class="" itemtype="https://schema.org/Thing" itemprop="item">
              <span itemprop="name">holydwoodskyline.com</span>
              <span class="color-white"> / </span>
            </a>
            <meta itemprop="position" content="1"/>
          </li>

          <li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope
              itemtype="http://schema.org/ListItem">
            <a :href="city_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
              &nbsp;<span itemprop="name">{{ companyDetails.name }} movies</span>
            </a>
            <meta itemprop="position" content="2"/>
          </li>

          <li v-if="gender || faculty" class="color-white mytitle1 myli" itemprop="itemListElement" itemscope
              itemtype="http://schema.org/ListItem">
            <a :href="university_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
              &nbsp;<span class="color-white"> / </span>
              <span itemprop="name">{{ companyDetails.name }} {{ genre }} Movies</span>
            </a>
            <meta itemprop="position" content="3"/>
          </li>
        </ul>


      </div>
      <span slot="title" v-if="companyDetails" v-html="pageTitle"></span>
      <div class="city-text" slot="text" style="color: #fff;
    font-size: 17px;
    opacity: 0.75;
    font-weight: 400;">
        <span v-if="studioDetails" v-html="spot"></span>
      </div>
             <div class="subpage-header-inf" slot="numbers">
              <div class="subpage-header-inf__item">
                <img src="@/assets/img/icon-uni.svg" alt="" class="subpage-header-inf__icon icon">
                <div class="subpage-header-inf__cnt">
                  <strong class="color-light-green d-block" v-if="!universityDetails">{{ total_results }}</strong>
                  <span>Movies</span>
                </div>
              </div>

<!--               <div class="subpage-header-inf__item">
                <img src="@/assets/img/icon-dorm-male.svg" alt="" class="subpage-header-inf__icon icon">
                <div class="subpage-header-inf__cnt">
                  <strong class="color-light-green d-block" v-if="universityDetails">{{ universityDetails.dorms_count }}</strong>
                  <span>Movies</span>
                </div>
              </div> -->
            </div> 
      <div class="uni-detail__card" slot="right" v-if="companyDetails">
        <UniInfoCard
          :logo="'http://image.tmdb.org/t/p/w185/' + logo_path"
          :website="homepage"
        />
      </div>
    </subpage-header>
    <div class="subpage__inner">
      <div class="gen uni" ref="dormTab">
        <container>
          <div class="dorm-tab uni">
            <div class="dorm-tab__header">
              <StudioTabNav :tabs="tabs"/>

              <!--<div class="mobile-dropdown" @click="edit">-->
              <!--<span class="filtre">-->
              <!--<svg-icon type="icon-filter"/>-->
              <!--</span>-->
              <!--<select-box title="Yurtları Filtrele"/>-->
              <!--</div>-->
              <!--<div class="section__right" v-if="show">-->
              <!--<div class="section__select">-->
              <!--<select-box :options="cities" title="Şehir Seçiniz"/>-->
              <!--</div>-->

              <!--<div class="section__select">-->
              <!--<select-box :options="dormTypes" title="Yurt Tipi Seçiniz"/>-->
              <!--</div>-->
              <!--</div>-->

<!--               <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="universityDetails"> -->
                    <VueSelectTempFacultyNoFilter placeholder="Select Genre" :options="genres"
                                   @onselect="selectGenre"/>
                    <!-- <v-select :options="countries" placeholder="Select Country" @onselect="selectFaculty"/> -->
                  <!-- </div>
                </div>
              </div> -->
            </div>
            <router-view/>
          </div>
        </container>
      </div>
      <container>
        <div class="seo-text" v-if="universityDetails">
          <p v-html="universityDetails.list_seo"></p> <br>
          <v-link
            class="button--more color-white subpage-header__btn seo-btn"
            :title="`${universityDetails.name} Hakkında Merak Edinler`"
            icon="icon-arrow-long-right"
            icon-position="right"
            :to="{ name: 'UniDetailAbout', params: { slug: this.$route.params.slug }}"
            slot="button"
          />
        </div>
      </container>
    </div>
   <!-- Fixed Button -->
  <v-button v-if="showGetPrice"
        class="button green round getBid my"
        icon="icon-studio"
        icon-position="left"
        title="Subscribe Studio News"
        @click.native="showSmsModal()"
      />
<!-- Fixed Button End -->
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >MESSAGE SENT!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Thank your for your interest.</span></p>
      <p ><span class= "mycolorBlue">Our friends will be in contact you soon.</span></p>
    </div>
     </div>
</div>
</Modal2>
<Modal2 :active="showErrorMessage" @onModalClose="closeModal3">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title2" >MESSAGE SENT!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Sory message can not be send now</span></p>
      <p ><span class= "mycolorBlue">Please try again later.</span></p>
    </div>
     </div>
</div>
</Modal2>
         <Modal2 :active="showModal" @onModalClose="closeModal">
          <div slot="content">
        <div class="dorm-form__inner mydorm-form-inner ">
          <div class="dorm-form__form">
            <div class="dorm-form-tab">
              <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
                <svg viewBox="0 0 20 20" class="icon" style="font-size: 30px; color: rgb(235, 96, 129);">
                  <use xlink:href="/icon/icons.svg#icon-studio-red"></use>
                </svg>
                <div class="dorm-form-tab__title">GET STUDIO NEWS</div>
                <!-- <div class="dorfm-form-tab__title">{{ smsarea }} LEARN STUDİO NEWS</div> -->
              </div>
            </div>
            <div id="my-form" ref="myMessageForm">
              <v-input ref="myInput" placeholder="Fullname" v-model="messageForm.name" v-on:keyup.native="saveForm"/>
              <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label>
              <VueInputRestricted placeholder="Email" v-on:keyup.native="saveForm" v-model="messageForm.phone"/>
              <label for="phone" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
              <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
              <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>
              <v-select
                v-if="messageForm.university_name === 'Select Genre' || messageForm.university_name === null || messageForm.university_name ===''"
                :options="universities" placeholder='Select Genre' :title="messageForm.university_name"
                @onselect="selectUniversity"/>
              <VueSelectTempUniversity v-else :options="universities" placeholder='Select Genre'
                                 :title="messageForm.university_name" @onselect="selectUniversity"/>
              <!-- <v-select :options="universities" placeholder="Üniversite Seçiniz" @onselect="selectUniversity"/> -->
              <label for="password" v-if="emptyUniversity" class="myValidationText">Can not be leave empty!</label>
              <!-- <VueSelect2
                v-if="messageForm.faculty_name === 'Fakülte Seç' && messageForm.university_name !='Üniversite Seç'"
                :options="faculties" placeholder='Fakülte Seç' @onselect="selectFacultyOnForm"/> -->

              <VueSelectTempFacultyNoFilter placeholder="Fakülte Seç" :options="faculties" @onselect="selectFacultyOnForm"/>

              <!-- <SelectBox2old :options="faculties" @onselect="selectFacultyOnForm"/> -->

              <label for="password" v-if="emptyFaculty" class="myValidationText">Can not be leave empty!</label>
              <VueSelectTempGender :options="genders" placeholder='Select Movie Type' @onselect="selectGender"/>
              <label for="phone" v-if="emptyGender" class="myValidationText">Can not be leave empty!</label>
<!--               <VueSelectTempGender v-if="genderSelected"
                                    placeholder="Yurt Tipi Seç" :options="genders" @onselect="selectGender"/>
              <v-select :options="genders" v-if="!genderSelected" placeholder="Yurt Tipi Seç" @onselect="selectGender"></v-select> -->
<!--               
              <v-input type="text" placeholder="E-Posta Adresi" v-on:keyup.native="saveForm"
                       v-model="messageForm.email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label> -->

              <div class="check-wrapper smart-map">
                <div class="check-wrapper__item">
                  <label class="container2" style="width: 100%;">
                    <div ref="mycheck" class="check"><input type="checkbox" v-model="checkedForm"
                                                            style="width: auto;"><span class="checkmark"></span>
                      <a href="/user-contract" class="" itemtype="https://schema.org/Thing" itemprop="item"
                         target="_blank">
                  <span
                    class="name">I have read Membership Agreement, I accept.</span></a>
                    </div>
                  </label>
                  <label for="password" v-if="emptyCheckForm" class="myValidationText">You need to accept the Membership Agreement!</label>
                </div>
              </div>

            </div>
            <v-button
              class="red fw mt-15 dorm-form__submit"
              title="SEND"
              v-if="messageEnabled"
              @click.native="sendSmsAll()"
            />
            <v-button
              class="red fw mt-15 dorm-form__submit"
              title="SENDING"
              v-if="!messageEnabled"
            />
          </div>
        </div>
      </div>
    </Modal2>
  </div>
</template>
<script>
import SubpageHeader from '@/components/SubpageHeader'
import FixedPopup from '@/components/FixedPopup'
import StudioTabNav from '@/components/Studio/StudioTabNav'
import UniInfoCard from '@/components/UniInfoCard'
import axios from 'axios'
import Modal2 from '@/components/Modal2'
import SelectBox2 from '@/components/SelectBox2'
import SelectBox2Old from '@/components/SelectBox2old'
import { mapGetters } from 'vuex'
import {
  GET_UNIVERSITY_DETAILS
} from '@/store/actions.type'
import Loading from 'vue-loading-overlay';
import VueInputRestricted from '@/components/VueInputRestricted'
import VueSelectTempUniversity from '@/components/VueSelectTempUniversity'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import VueSelectTempFacultyNoFilter from '@/components/VueSelectTempFacultyNoFilter'
import VueSelectTempGender from '@/components/VueSelectTempGender'
import VueSelect2 from '@/components/VueSelect2'
export default {
  name: 'Studio',
  components: {
    SubpageHeader, StudioTabNav, FixedPopup, UniInfoCard, Modal2, SelectBox2,SelectBox2Old, VueInputRestricted, Loading, VueSelectTempUniversity, VueSelectTempFaculty, VueSelectTempFacultyNoFilter, VueSelectTempGender, VueSelect2
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.universityDetails ? this.universityDetails.detail_title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.universityDetails ? this.universityDetails.detail_description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.universityDetails ? this.universityDetails.detail_keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.university_url},
      ]      
    }
  },
  data () {
    return {
      genre: '',
      companyDetails: {
        name:'Universal Studio',
        homepage: 'www.universal.com'
      },
      studioDetails: {

      },
      errors: [],
      messageEnabled: true,
      university_id: null,
      emptyCheckForm: false,
      checkedForm: false,      
      facultyEnabled: false,
      //logo_path: null,
      universities: [],
      faculties: [],
  genres: [
    {
      id: 28,
      name: "Action",
      slug: 'action'
    },
    {
      id: 12,
      name: "Adventure",
      slug: 'adventure'
    },
    {
      id: 16,
      name: "Animation",
      slug: 'animation'
    },
    {
      id: 35,
      name: "Comedy",
      slug: 'comedy'
    },
    {
      id: 80,
      name: "Crime",
      slug: 'crime'
    },
    {
      id: 99,
      name: "Documentary",
      slug: 'documentary'
    },
    {
      id: 18,
      name: "Drama",
      slug: 'drama'
    },
    {
      id: 10751,
      name: "Family",
      slug: 'family'
    },
    {
      id: 14,
      name: "Fantasy",
      slug: 'fantasy'
    },
    {
      id: 36,
      name: "History",
      slug: 'history'
    },
    {
      id: 27,
      name: "Horror",
      slug: 'horror'
    },
    {
      id: 10402,
      name: "Music",
      slug:'music'
    },
    {
      id: 9648,
      name: "Mystery",
      slug: 'mystery'
    },
    {
      id: 10749,
      name: "Romance",
      slug: 'romance'
    },
    {
      id: 878,
      name: "Science Fiction",
      slug: 'science-fiction'
    },
    {
      id: 10770,
      name: "TV Movie",
      slug: 'tv-movie'
    },
    {
      id: 53,
      name: "Thriller",
      slug: 'thriller'
    },
    {
      id: 10752,
      name: "War",
      slug: 'war'
    },
    {
      id: 37,
      name: "Western",
      slug: 'western'
    }
  ],      
      countries: [
        
{name: 'Sweden', code: 'SE'},
{name: 'France', code: 'FR'},
{name: 'Italy', code: 'IT'},
{name: 'Denmark', code: 'DK'},
{name: 'England', code: 'GB'},
{name: 'United States', code: 'US'},
{name: 'Canada', code: 'CA'},
{name: 'New Zealand', code: 'NZ'},
{name: 'Mexico', code: 'MX'},
{name: 'Japan', code: 'JP'},
{name: 'Russia', code: 'RU'},
{name: 'Brasil', code: 'BR'},
{name: 'Belgium', code: 'BE'},
{name: 'Germany', code: 'HR'},
{name: 'Australia', code: 'AU'},
{name: 'Finland', code: 'FI'},
{name: 'Germany', code: 'CH'},
{name: 'Chez Republic', code: 'CZ'},
{name: 'Austria', code: 'AT'},
{name: 'Luxemburg', code: 'LU'},
{name: 'Germany', code: 'KR'},
{name: 'Spain', code: 'ES'},
{name: 'Norwey', code: 'NO'},
{name: 'Israel', code: 'IS,'}
      ],
      showSuccessMessage: false,
      showErrorMessage: false,
      smsarea: '',
      list: 'university',
      list_id: '',
      list_name: '',
      isLoading: false,
      fullPage: true,
      showGetPrice: true,
      genders: [
        { id: 1, name: "See Movies" },
        { id: 2, name: "See Series" },
        ],
     // messageForm: {
        dorm_id: null,
        name: null,
        email: null,
        faculty_id: 1,
        messageForm: {
          dorm_id: null,
          name: null,
          email: null,
          university_id: null,
          faculty_id: '',
          phone: null,
          university_name: 'Select Studio',
          faculty_name: 'Select Genre'
        },
        showModal: false,
        falseEmail: false,
        falsePhone: false,
        shortPhone: false,
        genderSelected: false,
        emptyGender: false,
        emptyName: false,
        emptyPhone: false,
        emptyEmail: false,
        emptyEmail2: false,
        emptyUniversity: false,
        emptyFaculty: false,
        city_name: '',
        city_slug: '',
        city_url: '',
        university_url: '',
        gender1: 'old',
        tabs: [
          {
            id: 2,
            typeID: 2,
            cat: 'female',
            title: '<span class="color-pink">Kız <literal> Movies </literal>',
            icon: require('@/assets/img/icon-female.svg'),
            active: true
          },
          {
            id: 1,
            typeID: 1,
            cat: 'male',
            title: '<span class="color-blue">Erkek <literal> Movies </literal>',
            icon: require('@/assets/img/icon-male.svg'),
            active: false
          }
        ],
        typeID: null,
        gender: null,
        genderTitle: null,
        gender_name: 'Select Movie Type',
        faculty: null,
        opt: {}
      //}
    }
  },
    methods: {
      // getDorms () {
      //   let self = this
      //   axios.get(`/site/universities/dorms/${this.$route.params.slug}`)
      //     .then(response => {
      //       self.dorms = response.data.dorms
      //     })
      //     .catch(e => {
      //       this.errors.push(e)
      //     })
      // },
    string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },       
      saveForm () {
        window.localStorage.setItem('username', this.messageForm.name)
        window.localStorage.setItem('mail', this.messageForm.email)
        window.localStorage.setItem('phone1', this.messageForm.phone)
        //  window.localStorage.setItem('university_id', this.messageForm.university_id)
        //  window.localStorage.setItem('faculty_id', this.messageForm.faculty_id)
      },
      validateEmail (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      },
      sendSmsAll () {
        this.falseEmail = false
        this.falsePhone = false
        this.shortPhone = false
        this.emptyName = false
        this.emptyPhone = false
        this.emptyEmail = false
        this.emptyUniversity = false
        this.emptyFaculty = false
        this.emptyCheckForm = false
        this.emptyGender = false

        //const verifiedMail = this.validateEmail(this.messageForm.email)
        var self = this


/*         if (!this.messageForm.email) {
          this.emptyEmail = true
        } else if (this.messageForm.email && !verifiedMail) {
          this.falseEmail = true
        } */
        if (!this.messageForm.name) {
          this.emptyName = true
        }
        if (!this.messageForm.phone) {
          this.emptyPhone = true
        }

        if (this.messageForm.phone && !this.messageForm.phone.startsWith('0')) {
          this.falsePhone = true
        }

        if (this.messageForm.phone && !this.falsePhone && this.messageForm.phone.length != 11) {
          this.shortPhone = true
        }

        if (!this.messageForm.university_name || this.messageForm.university_name == 'Select Studio' || this.messageForm.university_name == 'null') {
          this.emptyUniversity = true
        }

  if(!this.checkedForm) {
    this.emptyCheckForm = true
  }

  if(!this.messageForm.faculty_name || this.messageForm.faculty_name == 'Select Faculty' ||this.messageForm.faculty_name == 'null') {
    this.emptyFaculty = true
  }

  if(!this.genderSelected) {
    this.emptyGender = true
  }


 if(this.list ==='faculty') {
 let a = 0
 //this.list_id = window.localStorage.getItem('list_id')
}

let dene2 = this.gender

if (!this.emptyName  && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity && !this.emptyFaculty && !this.emptyCheckForm && !this.emptyGender) {
          this.messageEnabled = false
          axios.post(`/site/dorm/message/multiple`, {
          email: 'empty@gmail.com', // this.messageForm.email,
          name: this.messageForm.name,
          phone: this.messageForm.phone,
          university_id: this.messageForm.university_id,
          faculty_id: this.list_id,
          list: 'faculty', //this.list,
          list_id: this.list_id,
          gender: this.typeID
        })

        .then(response => {
            if (response.status === 200 || response.status === 201) {
          self.messageEnabled = true
          self.closeModal()
          self.showSuccessMessage = true
            } else {
              self.closeModal()
              self.showErrorMessage = true
              self.messageEnabled = true
            }          
//          this.isLoading = false
        })
        .catch(e => {
              self.closeModal()          
              self.showErrorMessage = true
              self.messageEnabled = true
          self.errors.push(e)                    
        })
}
    },
    showSmsModal() {       
          if (!window.localStorage.getItem('typeID') || window.localStorage.getItem('typeID') === '' || window.localStorage.getItem('gender') === 'typeID') {
          } else {
                this.typeID = window.localStorage.getItem('typeID')
                this.genderSelected = true
                if(window.localStorage.getItem('typeID') === '1') {
                  this.gender_name = 'Erkek Öğrenci Yurdu'
                } else {
                  this.gender_name = 'Kız Öğrenci Yurdu'
                }
          }    
          // formda mail alanı kaldırıldı  
/*           if (!window.localStorage.getItem('mail') || window.localStorage.getItem('mail') === '' || window.localStorage.getItem('mail') === 'null') {
            this.messageForm.email = ''
          } else {
          this.messageForm.email = window.localStorage.getItem('mail')
        } */

        if (!window.localStorage.getItem('username') || window.localStorage.getItem('username') === '' || window.localStorage.getItem('username') === 'null') {
          this.messageForm.name = ''
        } else {
          this.messageForm.name = window.localStorage.getItem('username')
        }
        if (!window.localStorage.getItem('phone1') || window.localStorage.getItem('phone1') === '' || window.localStorage.getItem('phone1') === 'null') {
          this.messageForm.phone = ''
        } else {
          this.messageForm.phone = window.localStorage.getItem('phone1')
        }
        // email: window.localStorage.getItem('mail'),


        if (!window.localStorage.getItem('university_name') || window.localStorage.getItem('university_name') === '' || window.localStorage.getItem('university_name') === 'null') {
          this.messageForm.university_name = 'Üniversite Seç'
          this.facultyEnabled = false
        } else {
          // this.list = 'university'
          this.facultyEnabled = true
          // this.messageForm.university_name = window.localStorage.getItem('university_name')
          let self = this
          axios.get(`/selected/faculties/${window.localStorage.getItem('university_id')}`)
            .then(response => {
             self.faculties = response.data
            })
        }
/*         if (!window.localStorage.getItem('faculty_name') || window.localStorage.getItem('faculty_name') === 'null' || window.localStorage.getItem('faculty_name') === 'null') {
          this.messageForm.faculty_name = 'Fakülte Seç'
        } else {
          this.messageForm.faculty_name = window.localStorage.getItem('faculty_name')
        } */
         if (!window.localStorage.getItem('faculty_id') || window.localStorage.getItem('faculty_ide') === 'null' || window.localStorage.getItem('faculty_id') === 'null') {
           this.messageForm.faculty_name = 'Fakülte Seç'
        } else {
              this.list_id = window.localStorage.getItem('faculty_id')
              this.messageForm.faculty_name = window.localStorage.getItem('faculty_name')
        }

/*         if (!window.localStorage.getItem('gender') || window.localStorage.getItem('gender') === 'null' || window.localStorage.getItem('gender') === 'null') {
          //this.messageForm.faculty_name = 'Fakülte Seç'
        } else {
          // this.list = 'faculty'
          this.gender = window.localStorage.getItem('gender')
        }
 */
      this.showModal = true
      this.showGetPrice = false
    },
    closeModal() {
      this.showModal = false
      this.showGetPrice = true
    },
    closeModal2() {
      this.showSuccessMessage = false
    },
    closeModal3() {
      this.showErrorMessage = false
    },    
    checkFaculty () {
      if (!this.$route.params.faculty) {
        this.faculty = null
      } else {
       // this.faculty = this.$route.params.faculty
      }
    },
    checkGender () {
      if (this.$route.params.type === 'erkek') {
        this.gender = 'Erkek'
        this.gender_name = 'Erkek Öğrenci Yurdu'
        this.typeID = 1
        this.gender1 = 'erkek'
      } else if (this.$route.params.type === 'kiz') {
        this.gender = 'Kız'
        this.gender_name = 'Kız Öğrenci Yurdu'
        this.typeID = 2
        this.gender1 = 'kiz'
      } else {
        this.gender = null
        // this.faculty = null
      }
    },
    checkUniDetails () {
      const slug = this.$route.params.slug
      if (this.universityDetails) {
        if (this.universityDetails.slug !== slug) {
          this.$store.dispatch(GET_UNIVERSITY_DETAILS, null)
          this.getUniDetails()
        }
      } else {
        this.getUniDetails()
      }
    },
    setCityName(city_id) {
      let self = this
      axios.get('/site/cities/cities')
          .then(response => {
              //self.universities =
              response.data.forEach((data) => {
            if(data.id === city_id) {
              // window.localStorage.setItem('university_name', data.name)
              // ''self.messageForm.university_name = window.localStorage.getItem(data.name)
              self.city_name = data.name
              self.city_slug = self.getCitySlug(data.name)
              self.city_url = '/' + self.city_slug + '-movies/'
              self.university_url = '/' + self.universityDetails.slug  + '-movies/'
            }
            })
            })
              .catch(e => {
              this.errors.push(e)
            })
        },
    getCitySlug(city_name) {
                    //if(this.city_name !='') {
                        let str = city_name.toLowerCase()
                        str = str.replace('ş', 's')
                        str = str.replace('ı', 'i')
                        str = str.replace('ğ', 'g')
                        str = str.replace('ü', 'u')
                        str = str.replace('ö', 'o')
                        return str
/*                     } else {
                        return ''
                    } */

                },
    getUniDetails () {
      let self = this
      this.isLoading = true;
      axios.get(`/site/universities/detail/${self.$route.params.slug}`)
        .then(response => {
          this.isLoading = false;
          // let universities = response.data.sort()
          self.$store.dispatch(GET_UNIVERSITY_DETAILS, response.data)
          self.setCityName(response.data.city_id)
          const allSelection = {id:5555, name: "Tüm Fakülteler"}
          self.faculties = response.data.faculties
        self.faculties.unshift(allSelection)
          // self.list_id = response.data.id
          // self.list_name = response.data.name

          this.messageForm.university_name = response.data.name
          this.messageForm.university_id = response.data.id

          window.localStorage.setItem('university_name', response.data.name)
          window.localStorage.setItem('university_id', response.data.id)
          window.localStorage.setItem('university_id_constant', response.data.id)
          // self.universityDetails = response.data
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    selectUniversity (opt) {
      this.list = 'university'
      this.facultyEnabled = true
      this.messageForm.university_id = opt.id
      this.messageForm.university_name = opt.name
      window.localStorage.setItem('university_id', opt.id)
      window.localStorage.setItem('university_name', opt.name)
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFacultyOnForm (opt) {
      this.list = 'faculty'
      this.list_id = opt.id

      this.messageForm.faculty_name = opt.name
      this.messageForm.faculty_id = opt.id

      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)
    },
    selectGenre (opt) {
      this.genre = opt.name
      this.opt = opt
      this.faculty = true
      this.list = 'faculty'
      this.list_id = opt.id

      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)
/*
      this.messageForm.faculty_name = opt.name
      this.messageForm.faculty_id = opt.id

      window.localStorage.setItem('list', 'faculty')
      window.localStorage.setItem('list_id', opt.id)

      const slug = this.$route.params.slug
      // let route = { name: 'StudioGenre', params: { slug: slug, faculty: opt.slug } }
      let postfix = '-movies/'

      
      if(!opt.slug && opt.name) {
        opt.slug = this.string_to_slug(opt.name)
      }

      var route
      if(opt.name == "Tüm Fakülteler") {
           route = { name: 'Studio', params: { slug: this.$route.params.slug } }
           }
      else {


        route = '/' + this.$route.params.slug + '--' + opt.slug + '-movies/'

      if (this.$route.params.type) { 
      if (this.$route.params.type === 'erkek') {
        if(opt.slug.includes('fakultesi')) {
          route = '/' + this.$route.params.slug + '--' + opt.slug + '--movies/'
        } else {
          route = '/' + this.$route.params.slug + '--' + opt.slug + '-fakultesi--movies/'
        }
        
        }else {
                  if(opt.slug.includes('fakultesi')) {
          route = '/' + this.$route.params.slug + '--' + opt.slug + '--movies/'
        } else {
          route = '/' + this.$route.params.slug + '--' + opt.slug + '-fakultesi--movies/'
        }
        }
                  this.gender = null
          // this.faculty = null
      }
}
*/
// slug: this.$route.params.slug
   //this.companyDetails.name
   // const route = { name: 'UniversityFaculty', params: { studio:this.companyDetails.name, faculty:opt.name, slug:opt.name, genre:opt.id, id: this.$route.params.id} }
    const route = { name: 'StudioGenre', params: { studio:this.companyDetails.name, slug:this.$route.params.slug, type:opt.slug, genre:opt.slug, genreId:opt.id, id: this.$route.params.id} }

    this.$router.push(route)  
    }
    ,
      getCitySlug (city_name) {
        //if(this.city_name !='') {
        let str = city_name.toLowerCase()
        str = str.replace('ş', 's')
        str = str.replace('ı', 'i')
        str = str.replace('ğ', 'g')
        str = str.replace('ü', 'u')
        str = str.replace('ö', 'o')
        return str
        /*                     } else {
                                return ''
                            } */

      },
      selectGender(opt) {
        // this.gender = opt.id;
        this.typeID = opt.id
        this.genderSelected = true
        this.gender_name = opt.name
        window.localStorage.setItem('typeID', opt.id)
        window.localStorage.setItem('gender_name', opt.name)
      },
    filterFaculty (faculty) {
      // const faculty_name = window.localStorage.getItem('faculty_name')
      // return this.faculties.find((item) => item.slug === faculty)
      const faculty_name = 'deneme'
      return this.faculties.find((item) => item.name === faculty_name)
    },
      getUniversities () {
        var self = this
        axios.get('/selected/universities')
          .then(response => {
            self.universities = response.data
          })
          .catch(e => {
            this.errors.push(e)
          })
      },    
  },
    computed: {
      ...mapGetters(['universityDetails', 'total_results','logo_path','description', 'headquarters','homepage']),
      /*     sortedUniversityDetails () {
            return universityDetails.sort()
          },
          */
      pageTitle () {

/*         let gender = this.gender
        if (this.gender === '1') {
          gender = 'Erkek'
        } else if (this.gender === '2'){
          gender = Kız
        } */
      let type = ''
      if (this.gender == 'Erkek') {
        type = 'Series'
      } else {
        type = 'Movies'
      }
        this.companyDetails.name = this.$route.params.studio
        this.companyDetails.homepage = this.$route.params.homepage
        this.companyDetails.name = this.$route.params.studio
        this.description = this.$route.params.description
        const titleTemplate = '' //'Holywood Movies'
        let title = ''// 'Holywood Movies'
        if(this.companyDetails) {
        title = `<span class="color-light-green">${this.$route.params.studio}</span> Movies ${titleTemplate}`
        const route = this.$route.params
        if (route.genre) {
       //   const faculty = this.filterFaculty(route.faculty)
          if (this.gender && this.genre) {
            title = `<span class="color-light-green">${this.companyDetails.name} ${this.$route.params.studio} </span>${type} ${titleTemplate}`
          } else if (route.genre) {
            title = `<span class="color-light-green">${this.$route.params.studio} </span> <span class="color-light-blue">${this.genre} Movies </span>${titleTemplate}`
          }
        } else if (this.gender) {
          title = `<span class="color-light-green">${this.companyDetails.name} </span> ${type} ${titleTemplate}`
        }
        }
        return title
      },
      spot () {
        /*
        let title = this.universityDetails.spot
        const route = this.$route.params
        if (route.faculty) {
          const faculty = this.filterFaculty(route.faculty)
          if (this.gender === 'Erkek' && faculty) {
            title = faculty.male_spot
          } else if (this.gender === 'Kız' && faculty) {
            title = faculty.female_spot
          } else if(faculty){
            title = faculty.spot
          }
        } else if (this.gender) {
          if (this.gender === 'Erkek') {
            title = this.universityDetails.male_spot
          } else if (this.gender === 'Kız') {
            title = this.universityDetails.female_spot
          }
        }*/
        // const desc = window.localStorage.getItem('description')
                      if(this.$route.params.studio == "Miramax")
              return "Miramax is an American Film studio based in Emeryville, California, famous for films such as Pulp Fiction and Halloween."
              else if(this.$route.params.studio == "Metro-Goldwyn-Mayer")
return "Metro-Goldwyn-Mayer is an American Film studio and it is one the most important movie studio in Hollywood with the opportunities it provides."
              else return this.$route.params.description // + ' studios all movies are here. Find and see all movies for the company.' // is a company mostly producing any kind of movies.'
      
      }
    },//
    mounted () {
      //this.checkUniDetails()
      //this.getUniDetails()
    },
    created () {
     // this.logo_path = window.localStorage.getItem('logo_path')
      const dene = this.$route.params
     // this.checkUniDetails()
      this.checkGender()
      //this.getUniDetails()
      //this.getUniversities()
      // console.log('temporary log: ' + this.$route.params.slug)
    },
    watch: {
      $route () {
        this.checkGender()
        //this.checkFaculty()
        //this.getUniDetails()
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/components/city";

  .mytitle1 {
    font-size: 15px;
    color: white;
  }

  modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  /* Modal Content */
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 60%;
    height: 45%;
  }

  .mydorm-form-inner {
    background-color: white,
  }

  .myli {
    display: inline-block;
  }

  .mytitleUni {
    font-size: 12px;
    color: white;
  }

  .my1 {
    padding: 10px 20px !important;
    //  padding-bottom: 5px;
    bottom: 10px;
    position: left;
  }

</style>
